




import Vue from 'vue'

import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

const plugin = {
  id: 'custom_canvas_background_color',
  beforeDraw: (chart:any) => {
    if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
      const ctx = chart.canvas.getContext('2d');
      const chartArea = chart.chartArea;
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
      ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top)
      ctx.restore();
    }
  }
}

export default Vue.component('chart', {
  data () {
    return {
      chart: null
    }
  },
  created (this:any) {
    this.options.chartArea = { backgroundColor: 'white' }
  },
  mounted (this:any) {
    this.generateChart()
  },
  props: {
    id: String,
    type: String,
    data: Object,
    options: Object
  },
  // Generate the chart using the passed properties
  // id, data and options - update data & options
  methods: {
    generateChart: function (this:any) {
      var ctx = document.getElementById(this.id)
      this.chart = new Chart(ctx, {
        type: this.type,
        data: this.data,
        options: this.options,
        plugins: [plugin]
      })
    },
    updateChart: function (this:any) {
      this.chart.data = this.data
      this.chart.options = this.options
    }
  },
  // Watch for changes in the above computed models,
  // call update functions on change
  watch: {
    step1: function (this:any) {
      this.updateChart()
      this.chart.update()
    },
    step2: function (this:any) {
      this.updateChart()
      this.chart.update()
    }
  }
})
